module.exports = __webpack_public_path__ + "./images/xtrack-favicon.ico";